import type { CarbonIconType } from '@carbon/icons-react';
import { useTheme } from '@repo/theme';
import type { TLabel } from 'util/stdtypes';

import { BaseTag } from './base-tag';

export type ExperimentTagProps = ({ accent?: false; withBorder?: boolean } | { accent: true }) & {
    icon?: CarbonIconType;
    label?: TLabel;
    text?: string;
};

// Figma:
// https://www.figma.com/design/5vqFJlKdA6UAQJeXYlMQW2/PSI-Stage-2?node-id=14423-20655
export function ExperimentTag(props: ExperimentTagProps) {
    const { colors } = useTheme();

    if (props.accent && 'withBorder' in props)
        throw new Error('ExperimentTag: `accent` and `withBorder` are an unsupported combination in the design system.');
    if (!!props.label === !!props.text) throw new Error('ExperimentTag: either label or text must be provided, but not both');

    const backgroundColor = props.accent ? colors.colorTagAccent : colors.colorTagWhite;
    const textColor = props.accent ? colors.colorTextOnAccentColorBg : colors.colorTextOnTagLight;
    const border = !props.accent && props.withBorder ? 'dashed' : undefined;

    return (
        <BaseTag
            backgroundColor={backgroundColor}
            border={border}
            caps
            color={textColor}
            iconFill={textColor}
            label={props.label}
            prefix={props.icon}
            text={props.text}
            type='small'
        />
    );
}
